import { restoreMediaViewSelection } from "./restoreMediaViewSelection.js";
import { getRmlMediaBridge } from "../hooks/tree/bridge/rmlMediaBridge.js";
function isAttachmentsBrowserSortable(attachmentsBrowser) {
    try {
        const $el = attachmentsBrowser?.attachments?.$el;
        if (!$el?.length) {
            return false;
        }
        return !$el.sortable("option", "disabled");
    } catch (e) {
        return false;
    }
}
const GALLERY_EDIT_TOOLBAR_MODES = [
    "gallery-edit",
    "playlist-edit",
    "video-playlist-edit"
];
function resolveMediaToolbarMode(view) {
    const candidate = view;
    const state = candidate.controller?.state?.();
    if (state?.id && GALLERY_EDIT_TOOLBAR_MODES.includes(state.id)) {
        return state.id;
    }
    return candidate.options?.model?.get?.("toolbar") ?? state?.get?.("toolbar");
}
function isAttachmentsGalleryEdit(attachments) {
    try {
        const toolbar = resolveMediaToolbarMode(attachments);
        return !!toolbar && GALLERY_EDIT_TOOLBAR_MODES.includes(toolbar);
    } catch (e) {
        return false;
    }
}
/**
 * When a tree gets initialized then check if it is a modal and modify the state.
 */ function applyModalTreeInit(controller, state, { isModal }) {
    if (isModal && controller.attachmentsBrowser) {
        const browser = controller.attachmentsBrowser;
        if (isAttachmentsGalleryEdit(browser)) {
            return;
        }
        state.isResizable = false;
        state.isSticky = false;
        state.isStickyHeader = false;
        state.isFullWidth = true;
        state.isWPAttachmentsSortMode = isAttachmentsBrowserSortable(browser);
        const changeOrderBy = ()=>controller.setState({
                isWPAttachmentsSortMode: isAttachmentsBrowserSortable(browser)
            });
        const { props } = browser.collection;
        props.on("change:orderby", changeOrderBy);
        controller._unsubscribeChangeOrderBy = ()=>props.off("change:orderby", changeOrderBy);
        const { controller: { modal } } = browser;
        restoreMediaViewSelection(modal._rmlFolder, controller.props.store, getRmlMediaBridge(controller.attachmentsBrowser), ({ id })=>{
            browser.attachments._rmlInitialSetted = true;
            state.initialSelectedId = id;
        });
    }
}
/**
 * When a modal tree gets destroyed save the last selected folder in the modal.
 */ function applyModalTreeDestroy(controller, _state, { isModal, store }) {
    if (isModal && controller.attachmentsBrowser) {
        const browser = controller.attachmentsBrowser;
        browser.controller.modal._rmlFolder = store.selectedId;
        const { _unsubscribeChangeOrderBy } = controller;
        _unsubscribeChangeOrderBy?.();
        controller._unsubscribeChangeOrderBy = undefined;
    }
}
function prepareModalSidebar(context) {
    if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */ }
}
export { applyModalTreeDestroy, applyModalTreeInit, isAttachmentsGalleryEdit, prepareModalSidebar };
